import { render, staticRenderFns } from "./GeneDetail.vue?vue&type=template&id=3ce8b2c8&scoped=true"
import script from "./GeneDetail.vue?vue&type=script&lang=js"
export * from "./GeneDetail.vue?vue&type=script&lang=js"
import style0 from "./GeneDetail.vue?vue&type=style&index=0&id=3ce8b2c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce8b2c8",
  null
  
)

export default component.exports